import { render } from "./InventarioBazar.vue?vue&type=template&id=4542d150"
import script from "./InventarioBazar.vue?vue&type=script&lang=js"
export * from "./InventarioBazar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\COSMI\\Desktop\\appwebantiguo\\vue-op-vanguardia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__